import { render, staticRenderFns } from "./MyBenefits.vue?vue&type=template&id=5ac5b65a&scoped=true&"
import script from "./MyBenefits.vue?vue&type=script&lang=js&"
export * from "./MyBenefits.vue?vue&type=script&lang=js&"
import style0 from "./MyBenefits.vue?vue&type=style&index=0&id=5ac5b65a&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac5b65a",
  null
  
)

export default component.exports